import useEmailPasswordRecoveryForm, {
  EmailPasswordRecoveryFieldType,
} from '@/pages/authentication/EmailPasswordRecovery/EmailPasswordRecoveryForm/useEmailPasswordRecoveryForm.ts';
import { LoginFieldType } from '@/pages/authentication/Login/LoginForm/useLoginForm.ts';
import ThemeButton from '@/theme/Components/ThemeButton/ThemeButton.tsx';
import { Form, Input, Typography } from 'antd';

interface EmailPasswordRecoveryFormProps {
  handleContent: () => void;
}

const EmailPasswordRecoveryForm = ({
  handleContent,
}: EmailPasswordRecoveryFormProps) => {
  const { onFinish, userType, t, data } = useEmailPasswordRecoveryForm({
    handleContent,
  });

  return (
    <Form
      autoComplete="off"
      initialValues={{ sec_token: data?.pageData?.attributes?.sec_token || '' }}
      name="email-password-recovery-form"
      onFinish={onFinish}
      style={{ width: '100%' }}
    >
      <Form.Item<EmailPasswordRecoveryFieldType>
        name={'email'}
        rules={[
          {
            type: 'email',
            message: t(`lostpassword.${userType}.invalid_email_message`),
          },
          {
            required: true,
            message: t(`lostpassword.${userType}.required_email_message`),
          },
        ]}
      >
        <Input
          placeholder={t(`lostpassword.${userType}.email_placeholder`)}
          variant="filled"
        />
      </Form.Item>

      <Form.Item<LoginFieldType> hidden={true} name="sec_token">
        <Input.Password />
      </Form.Item>

      <Form.Item label={null}>
        <ThemeButton block htmlType="submit" type="primary">
          {t(`lostpassword.${userType}.actions.send_reset`)}
        </ThemeButton>
      </Form.Item>

      <Typography style={{ textAlign: 'center' }}>
        <Typography.Link onClick={handleContent}>
          {t(`lostpassword.${userType}.actions.back_login`)}
        </Typography.Link>
      </Typography>
    </Form>
  );
};

export default EmailPasswordRecoveryForm;
